import { computed } from 'vue'
import { useFetchCalendarStaffsQuery } from './useCalendar.generated.ts'

export const useCalendar = () => {
  const { result, refetch } = useFetchCalendarStaffsQuery({
    fetchPolicy: 'no-cache',
  })

  const isCalendarAvailable = computed(() => {
    if (!result.value) {
      return undefined
    }

    return result.value.staffsByPlanner.some(
      staff => staff.connectedThirdPartyProvider
    )
  })

  return {
    isCalendarAvailable,
    refetch,
  }
}
